// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-6ae90b7a]{min-width:150px;width:100%;margin:0 auto;position:relative;margin-bottom:5px}[data-v-6ae90b7a] .toolbar{border:1px solid #ccc;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:#f1f1f1}[data-v-6ae90b7a] .toolbar .w-e-menu{font-size:12px!important;padding:0 6px!important;z-index:auto!important}[data-v-6ae90b7a] .text{border:1px solid #ccc;height:450px!important;font-size:16px!important}", ""]);
// Exports
module.exports = exports;
